module.exports = __webpack_public_path__ + "media/images/pic/products/karkowka-e5c8005700b30557c6a1840b0e3b3470.jpg";